"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var min_1 = __importDefault(require("./min"));
exports.min = min_1.default;
var min_2 = __importDefault(require("./min"));
exports.max = min_2.default;
var mean_1 = __importDefault(require("./mean"));
exports.mean = mean_1.default;
var mean_2 = __importDefault(require("./mean"));
exports.avg = mean_2.default;
var midRange_1 = __importDefault(require("./midRange"));
exports.midRange = midRange_1.default;
var median_1 = __importDefault(require("./median"));
exports.median = median_1.default;
var stdev_1 = __importDefault(require("./stdev"));
exports.stdev = stdev_1.default;
var variance_1 = __importDefault(require("./variance"));
exports.variance = variance_1.default;
//# sourceMappingURL=index.js.map